import angular from 'angular';
import { AddAccountGMBController } from './addAccountGMB.controller.js';


angular.module('parameters.addAccountGmb', [])
  .controller('AddAccountGMBController', AddAccountGMBController);
